import React from 'react';
import './pet-profile-avatar.scss';

type PetProfileAvatarProps = {
  size?: 'small' | 'medium' | 'large' | 'huge';
  imageUrl: string;
  className?: string;
  testid?: string;
};
const PetProfileAvatar = ({
  size = 'large',
  imageUrl,
  className,
  testid,
}: PetProfileAvatarProps) => {
  let petAvatarClasses = `pet-profile-avatar pet-profile-avatar--${size} pet-profile-avatar--pet`;
  if (className) {
    petAvatarClasses += ` ${className}`;
  }
  return (
    <div
      data-testid={testid || 'pet-profile-avatar'}
      className={petAvatarClasses}
      style={{ backgroundImage: `url('${imageUrl}')` }}
    />
  );
};

export default PetProfileAvatar;
